import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class RootIndex extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
        }
    }

    
    getUrlAgrupador = (agrupador = "") => {
        // console.log(agrupador);
        switch(agrupador) {
            case "Administradores":
                return "/administradores";
            case "Usuarios":
                return "/permisos"
            case "Reportes":
                return "/reportes"
            case "Configuradores":
                return "/configuradores"
            case "Boletín de Inteligencia":
                return "/boletin"
            case "Recursos":
                return "/recurso"
            case "Eventos":
                return "/eventos"
            case "Notificaciones":
                return "/notificaciones"
            case "Ficha Partida":
                return "/ficha-partida"
            case "Ficha Mercado":
                return "/ficha-pais"
            case "Emailing":
                return "/emailing"
            // case "Paises":
            //     return "/ficha-pais"
            // default:
            //   return "/boletin";
        }
    }

    getIconoAgrupador = (agrupador = "") => {
        switch(agrupador) {
        case "Administradores":
            return "./static/images/icoAdministrador.png";
        case "Usuarios":
            return "../static/images/icoUsuarios.png"
        case "Reportes", "Emailing":
            return "../static/images/icoReportes.png"
        case "Configuradores":
            return "../static/images/icoConfiguracion.png"
        case "Eventos":
            return "../static/images/events.svg"
        case "Ficha Partida":
            return "../static/images/icoProducto.png"
        case "Ficha Mercado":
            return "../static/images/icoPais.png"
        case "Notificaciones":
            return "../static/images/notifications.svg"   
        case "Cache":
            return "../static/images/icoCache.svg"    
        default:
            return "./static/images/icoAdministrador.png";
        }
    }

    render() {
        // console.log(this.state.user);
        return (
            <div id="containerPanel">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                            <a  href="/">
                                / Panel de Configuración General
                            </a >
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Panel de Configuracion General
                </div>
                <div className="divConfiguracion_Modulos">
                    {
                        /*
                            optList.includes("/recurso") &&
                            <div className="divModulos_General">
                                <Link to={{
                                    pathname:'/recurso',
                                    state: { menus: '/recurso', agrupador:'boletin', menuGeneral: ''},
                                }}>
                                    <img src={this.getIconoAgrupador('boletin')} alt="" />
                                    <span>{'Recursos'}</span>
                                </Link>
                            </div>
                        */
                    }

                    { 
                        //this.state.menu.length > 0 ?
                        this.props.menu.length > 0 ?
                        this.props.menu.map((resource, key) => {
                        //this.state.menu.map((resource) => (
                            let url = this.getUrlAgrupador(resource.sAgrupador);
                            // console.log(url);

                            // if(optList.includes(url)){
                                return <div key={key} className="divModulos_General">
                                    <Link to={{
                                        pathname: this.getUrlAgrupador(resource.sAgrupador),
                                        //state: { menus: resource.sMenu, agrupador:resource.sAgrupador, menuGeneral: this.state.menuGeneral},
                                        state: { menus: resource.sMenu, agrupador:resource.sAgrupador, menuGeneral: this.props.menuGeneral},
                                    }}>
                                        <img src={ this.getIconoAgrupador(resource.sAgrupador)} alt="" />
                                        <span>{resource.sAgrupador}</span>
                                    </Link>
                                </div>
                            // }
                        })
                        : ''
                    }

                    {/* <div className="divModulos_General">
                            <Link to={{
                                pathname:'/emailing',
                                state: { 
                                    menus: '/emailing', 
                                    agrupador:'', 
                                    menuGeneral: ''
                                },
                            }}>
                                <img src={this.getIconoAgrupador('Emailing')} alt="" />
                                <span>{'Emailing'}</span>
                            </Link>
                        </div> */}

                    {this.state.user.Tusu_EsSuperAdmin &&
                        <div className="divModulos_General">
                            <Link to={{
                                pathname:'/cache',
                                state: { 
                                    menus: '/cache', 
                                    agrupador:'', 
                                    menuGeneral: ''
                                },
                            }}>
                                <img src={this.getIconoAgrupador('Cache')} alt="" />
                                <span>{'Caché de Fichas'}</span>
                            </Link>
                        </div>
                    }
                        

                    {this.props.menu.length === 0 &&
                        <div>Usted no cuenta con permisos asignados</div>
                    }

                    <div className="clear" />
                </div>
            </div>
        )
    }
}